import { render } from "./WhoWeAreSection.vue?vue&type=template&id=5b832d53&scoped=true"
import script from "./WhoWeAreSection.vue?vue&type=script&lang=js"
export * from "./WhoWeAreSection.vue?vue&type=script&lang=js"

import "./WhoWeAreSection.vue?vue&type=style&index=0&id=5b832d53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b832d53"]])

export default __exports__